import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import CourseHeader from './CourseHeader';
import TabNav from './TabNav';
import { img } from '../../config';
import { useParams } from 'react-router-dom';
import P404 from '../P404';
import { setCurrentCourse } from '../../redux/actions';

function Course(props) {
  const params = useParams();
  const courseSlug = params.course;
  const { course } = props;
  const currentPermalink = params.course;

  useEffect(() => {
    // if (props.courseSections.length) return;
    updateCourse();
    // eslint-disable-next-line
  }, [currentPermalink]);

  const updateCourse = () => {
    const course = props.courses.find(course => course.permalink === courseSlug);
    props.setCurrentCourse(course);
  }

  if (!course) return 'Loading, please wait...';
  if (!course.id) return <P404 />

  const { passedPercent, title } = course;

  return (
    <>
      <CourseHeader
        imgSrc={img(course.img)}
        progress={passedPercent}
        title={title}
        subtitle=""
      />
      <TabNav params={params} />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    courses: state.courses,
    course: state.course,
    courseSections: state.courseSections,
  }
}

export default connect(mapStateToProps, { setCurrentCourse })(Course);
